import React, { Component } from "react";
import PropTypes from "prop-types";
import _get from "lodash/get";
import { BWGridAPI, GridHeader, GridTable } from "../../ui/BWGrid";
import Paper from "../../mui/core/Paper";
import AddCircle from "@material-ui/icons/AddCircle";
import LocationCombined from "../../ui/LocationCombined";
import PointOfContactColumn from "./PointOfContactColumn";
import propTypes from "../../../constants/propTypes";
import { roleCan } from "../../../utils/roleUtils";
import TagText from "../../ui/Tags/TagText";

export default class RemitAddressesPage extends Component {
  static propTypes = {
    dataComponent: PropTypes.object.isRequired,
    openModalDialog: PropTypes.func,
    isModalOpen: PropTypes.bool,
    push: PropTypes.func.isRequired,
    vendorId: PropTypes.string.isRequired,
    refreshRemitAddressTable: PropTypes.func.isRequired,
    userRole: propTypes.userRole,
  };

  _modalHasClosed = prevProps => {
    return !this.props.isModalOpen && prevProps.isModalOpen;
  };

  _handleModalClosed = () => {
    this.props.refreshRemitAddressTable();
  };

  componentDidUpdate(prevProps) {
    if (this._modalHasClosed(prevProps)) {
      this._handleModalClosed();
    }
  }

  handleAddButtonClick = () => {
    const { vendorId, vendor } = this.props;
    this.props.openModalDialog(
      "Create Remit Address",
      "CreateRemitAddressContainer",
      { vendorId, titleModal: "Create Remit Address", vendor },
      false
    );
  };

  handleEditOptionClick = remitAddress => {
    const { vendor } = this.props;
    this.props.openModalDialog(
      "Edit Remit Address",
      "EditRemitAddressContainer",
      { remitAddress, titleModal: "Edit Remit Address", vendor },
      false
    );
  };

  handleDeleteOptionClick = ({ id, name: title }) => {
    this.props.openModalDialog(
      `Delete ${title}`,
      "DeleteRemitAddress",
      { id, title },
      true,
      false
    );
  };

  _getRootFilters() {
    const { vendorId } = this.props;
    let rootFilters = {};

    if (vendorId) {
      rootFilters = {
        $where: {
          vendorId: vendorId,
        },
      };
    }

    return rootFilters;
  }

  _getRowMenu() {
    const { userRole } = this.props;
    const canEdit = roleCan(userRole, "edit-remit-addresses");
    const canDelete = roleCan(userRole, "delete-remit-addresses");

    const menu = [];

    if (canEdit) {
      menu.push({ text: "Edit", onClick: this.handleEditOptionClick });
    }

    if (canDelete) {
      if (menu.length > 0) {
        menu.push({ separator: true });
      }
      menu.push({ text: "Delete", onClick: this.handleDeleteOptionClick });
    }

    return menu.length > 0 ? menu : null;
  }

  render() {
    return (
      <Paper>
        <BWGridAPI
          {...this.props}
          includes={["location", "pointOfContacts.contact.person"]}
          rootFilters={this._getRootFilters()}
          defaultFiltering={[{ columnName: "isActive", value: true }]}
        >
          <GridHeader
            headerText="Remit Addresses"
            actions={[
              {
                text: "ADD ADDRESS",
                icon: <AddCircle />,
                handler: this.handleAddButtonClick,
                disableIfProjectClosed: true,
              },
            ]}
          />
          <GridTable
            columns={[
              "label",
              "name",
              "location.address",
              "isActive",
              "pointOfContact",
            ]}
            columnOptions={{
              label: { bold: true, filter: true },
              name: { bold: true, filter: true },
              "location.address": {
                title: "Address",
                render: LocationCombined,
              },
              isActive: {
                title: "Status",
                filter: "select",
                filterOptions: {
                  initialOption: true,
                  options: [
                    { id: true, name: "Active" },
                    { id: false, name: "Inactive" },
                  ],
                },
                render: row => {
                  const isActive = _get(row, "isActive", false);
                  const text = isActive ? "Active" : "Inactive";
                  return row.id && <TagText>{text}</TagText>;
                },
              },
              pointOfContact: {
                sortingEnabled: false,
                fill: true,
                render: PointOfContactColumn,
              },
            }}
            rowMenu={this._getRowMenu()}
          />
        </BWGridAPI>
      </Paper>
    );
  }
}
